import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { CashFlowService } from '../service/cashflow.service';
import { CompanyService } from '../service/company.service';
import { ProjectService } from '../service/project.service';

@Component({
  selector: 'app-cover-page',
  templateUrl: './cover-page.component.html',
  styleUrls: ['./cover-page.component.css'],
})
export class CoverPageComponent implements OnInit {
  constructor(
    public cashflowservice: CashFlowService,
    private companyService: CompanyService,
    private projectService: ProjectService
  ) {
    this.print = false;
    this.projectId = localStorage.getItem('projectId');
    this.companyId = localStorage.getItem('companyId');
    this.getProjectCompanyDetails();
  }

  @Output() coverEmit: EventEmitter<any> = new EventEmitter();

  @Input() print: boolean;

  companyLogoUrl = '';

  projectName: string;

  companyId: string;

  projectId: string;

  ngOnInit() {}

  // TO GET CASHFLOW'S DATA, COMPANY AND PROJECT DATA TO SHOW DATA IN COVER PAGE FOR PRINTING ONLY
  getProjectCompanyDetails() {
    this.cashflowservice.getCashFlow();
    this.companyService.getCompany(this.companyId).subscribe((res) => {
      this.companyLogoUrl = res.data[0].logoUrl;
      this.projectService.getProject(this.projectId).subscribe((projectData) => {
        this.projectName = projectData.data[0].project_name;
        this.coverEmit.emit({ coverEmit: true });
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/cover-page/cover-page.component.ts